<template>
  <div>
    <PageName
      :title="`${isEdit ? 'Редактировать' : 'Создать'} причину обмена/возврата`"
    />
    <Form :value="reason" @request="saveReason" class="create__reason">
      <div class="create__reason-form">
        <VInput name="name" required placeholder="Причина" />
      </div>
      <div>
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          :text="isEdit ? 'Сохранить' : 'Создать'"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin-top: 12px"
        />
      </div>
    </Form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getReturnReason, createReturnReason, updateReturnReason } from "@/api/returnReasons";
import PageName from "@/components/PageName.vue";
import Form from "@/components/Form/Form";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";

export default {
  name: "saveReason",
  components: {
    PageName,
    Form,
    VInput,
    Button,
  },
  props: {
    action: String,
  },
  data() {
    return {
      reason: {},
      reasonLoading: true,
      id: null,
      saveLoading: false,
    };
  },
  async mounted() {
    if (this.isEdit) {
      this.id = parseInt(this.$route.params.id_reason);
      await getReturnReason(this.id).then((res) => {
        this.reason = res.data;
      });
    }
  },
  computed: {
    isEdit() {
      return this.action === "update";
    },
    isCreate() {
      return this.action === "create";
    },
  },
  methods: {
    ...mapActions("returnReasons", ["getReturnReasons"]),
    async saveReason(data) {
      this.saveLoading = true;
      if (!this.isEdit) {
        await createReturnReason(data.name);
      } else {
        await updateReturnReason(
          data.id,
          data.name
        );
      }
      this.saveLoading = false;
      this.getReturnReasons();
      this.$router.push({ name: "ReturnReasons" });
    },
  },
};
</script>

<style scoped lang="scss">
.create__reason {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  .create__reason-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;
  }
}
</style>
